import EmojiAutoCompleteList from "./EmojiAutoCompleteList";

export default EmojiAutoCompleteList;
